// swiperInit.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const multiColumCards = document.querySelectorAll('.testimonial-section');

    multiColumCards.forEach(section => {
        const cardSlider = section.querySelectorAll('.ts-slider');

        if (cardSlider.length > 0) {
            cardSlider.forEach(slider => {
                new Swiper(slider, {
                    loop: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    slidesPerView: 1,
                    allowTouchMove: true,
                    spaceBetween: 0,
                    autoHeight: true,
                    pagination: {
                        el: section.querySelector('.ts-pagination'),
                        type: 'fraction',
                    },
                    navigation: {
                        prevEl: section.querySelector('.ts-button-prev'),
                        nextEl: section.querySelector('.ts-button-next'),
                    },
                    breakpoints: {
                        992: {
                            allowTouchMove: false,
                            simulateTouch: false,
                            preventClicks: false,
                            preventClicksPropagation: false,
                        },
                    },
                });
            });
        }
    });
});